var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "76px",
    viewBox: "0 0 54.0 76.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1719,0 C35.9863,0 45.8008,6.6894 45.8008,21.6797 L45.8,31.133 L45.8202973,31.136714 C50.1022904,31.8571891 52.3018553,34.7536605 52.38985,40.00098 L52.3926,40.332 L52.3926,66.06444 C52.3926,72.46093 49.4141,75.48827 43.5059,75.48827 L8.8867,75.48827 C2.9785,75.48827 0,72.46093 0,66.06444 L0,40.332 C0,34.8752912 2.20110142,31.872199 6.57230269,31.136714 L6.64,31.125 L6.6406,21.6797 C6.6406,6.839303 16.2118646,0.13461809 25.8789388,0.0020084315 Z M43.2129,37.5 L9.1797,37.5 C7.8125,37.5 7.0312,38.2324 7.0312,39.8437 L7.0312,66.55272 C7.0312,68.16405 7.8125,68.9453 9.1797,68.9453 L43.2129,68.9453 C44.6289,68.9453 45.3613,68.16405 45.3613,66.55272 L45.3613,39.8437 C45.3613,38.2324 44.6289,37.5 43.2129,37.5 Z M26.1719,6.543 C19.6289,6.543 13.5254,11.1816 13.5254,20.6543 L13.525,30.957 L38.915,30.957 L38.916,20.6543 C38.916,11.3131653 32.9334104,6.6727825 26.4462887,6.5456849 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-905.5426 -3.2461000000000695)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(906.1876 3.27150000000006)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 52.3926,0 52.3926,75.48827 0,75.48827 0,0",
    stroke: "none",
    fill: "#FF3B30"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock_closed.5b6e0ae03aa19c8ba338384a021104ec.svg";
export { ForwardRef as ReactComponent };